import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const MultiLanguage = makeShortcode("MultiLanguage");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`PostHog's backend SDKs and API capture identified events by default. To capture anonymous events, set the `}<inlineCode parentName="p">{`$process_person_profile`}</inlineCode>{` property to `}<inlineCode parentName="p">{`false`}</inlineCode>{`:`}</p>
    <MultiLanguage mdxType="MultiLanguage">
      <pre><code parentName="pre" {...{
          "className": "language-node"
        }}>{`client.capture({
    distinctId: 'distinct_id_of_the_user',
    event: 'your_event_name',
    properties: {
        $process_person_profile: false,
    },
})
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-python"
        }}>{`posthog.capture(
    "distinct_id_of_the_user", 
    "your_event_name", 
    {
        "$process_person_profile": false
    }
)
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-php"
        }}>{`PostHog::capture(array(
  'distinctId' => 'distinct_id_of_the_user',
  'event' => 'your_event_name',
  'properties' => array(
    '$process_person_profile' => false
  )
));
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-ruby"
        }}>{`posthog.capture({
    distinct_id: 'distinct_id_of_the_user',
    event: 'your_event_name',
    properties: {
        $process_person_profile: false
    }
})
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-go"
        }}>{`client.Enqueue(posthog.Capture{
    DistinctId: "distinct_id_of_the_user",
    Event:      "your_event_name",
    Properties: posthog.NewProperties().
      Set("$process_person_profile", false),
})
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-java"
        }}>{`posthog.capture("distinct_id_of_the_user", "your_event_name", new HashMap<String, Object>() {
  {
    put("$process_person_profile", false);
  }
});
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-rust"
        }}>{`let mut event = Event::new("your_event_name", "distinct_id_of_the_user");

event.insert_prop("$process_person_profile", false).unwrap();

client.capture(event).unwrap();
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-elixir"
        }}>{`Posthog.capture("your_event_name", %{
  distinct_id: distinct_id_of_the_user,
  properties: %{
    "$process_person_profile": false
  }
})
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-bash"
        }}>{`curl -v -L --header "Content-Type: application/json" -d '{
    "api_key": "<ph_project_api_key>",
    "properties": {
        "$process_person_profile": false
    },
    "distinct_id": "distinct_id_of_the_user",
    "event": "your_event_name"
}' <ph_client_api_host>/i/v0/e/
`}</code></pre>
    </MultiLanguage>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      